import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Location from './components/Location';
import Contact from './components/Contact';
import Navigation from './components/Navigation';
import FAQ from './components/FAQ';

const SCHEMA_JSON = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "EntertainmentBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#business`,
      "name": "부산호스트바",
      "alternateName": "BUSANHOST",
      "url": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/`,
      "telephone": "+82-10-5781-5340",
      "description": "부산호스트바는 서면·해운대·광안리·연산동 4개 지점에서 운영하는 프리미엄 호스트바입니다. 10년 이상 경력의 전문 호스트 매칭, VIP 서비스, 24시간 예약 가능.",
      "priceRange": "$$$$",
      "currenciesAccepted": "KRW",
      "paymentAccepted": "Cash, Credit Card",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+82-10-5781-5340",
        "contactType": "reservations",
        "availableLanguage": "Korean",
        "hoursAvailable": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
          "opens": "00:00",
          "closes": "23:59"
        }
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"],
          "opens": "00:00",
          "closes": "23:59"
        }
      ],
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "신천대로62번길 67",
        "addressLocality": "부산진구",
        "addressRegion": "부산광역시",
        "postalCode": "47296",
        "addressCountry": "KR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.1579,
        "longitude": 129.0590
      },
      "areaServed": {
        "@type": "City",
        "name": "부산광역시"
      },
      "sameAs": [
        "https://www.instagram.com/busanhostbar",
        "https://pf.kakao.com/busanhostbar"
      ]
    },
    {
      "@type": "WebSite",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#website`,
      "url": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/`,
      "name": "부산호스트바",
      "description": "부산 서면·해운대·광안리·연산동 프리미엄 호스트바 공식 사이트",
      "inLanguage": "ko-KR",
      "publisher": {
        "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#business`
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "WebPage",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#webpage`,
      "url": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/`,
      "name": "부산호스트바 - 부산 010-5781-5340 서면·해운대·광안리 프리미엄 호스트바",
      "description": "부산호스트바는 서면·해운대·광안리·연산동 4개 지점에서 운영하는 프리미엄 호스트바입니다. 10년 이상 경력의 전문 호스트 매칭, VIP 서비스, 24시간 예약 가능. 부산 최고의 엔터테인먼트 경험을 제공합니다.",
      "inLanguage": "ko-KR",
      "datePublished": "2024-01-01",
      "dateModified": "2026-03-23",
      "isPartOf": { "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#website` },
      "about": { "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#business` },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "홈",
            "item": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "서비스 안내",
            "item": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#services`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "오시는 길",
            "item": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#location`
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "자주 묻는 질문",
            "item": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#faq`
          }
        ]
      }
    },
    {
      "@type": "FAQPage",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#faq`,
      "mainEntity": [
        {
          "@type": "Question",
          "name": "부산호스트바 예약은 어떻게 하나요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "전화(010-5781-5340) 또는 문자 메시지로 24시간 예약 가능합니다. 홈페이지 문의 폼을 통해서도 예약 문의를 남기실 수 있습니다."
          }
        },
        {
          "@type": "Question",
          "name": "부산호스트바 지점은 어디에 있나요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "서면지점(부산진구 신천대로62번길 67), 해운대지점(해운대구 구남로 37), 광안리지점(수영구 광안해변로 197), 연산지점(연제구 반송로 32-8) 총 4개 지점을 운영 중입니다."
          }
        },
        {
          "@type": "Question",
          "name": "부산호스트바 운영 시간은 어떻게 되나요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "매일 24시간 연중무휴로 운영합니다."
          }
        },
        {
          "@type": "Question",
          "name": "부산호스트바 VIP 서비스란 무엇인가요?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "최고급 프라이빗 공간에서 전문 호스트와 함께하는 프리미엄 엔터테인먼트 서비스입니다. 고객님의 취향에 맞는 호스트 매칭과 맞춤형 서비스를 제공합니다."
          }
        }
      ]
    },
    {
      "@type": "LocalBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#seomyeon`,
      "name": "부산호스트바 서면지점",
      "parentOrganization": { "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#business` },
      "telephone": "+82-10-5781-5340",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "신천대로62번길 67",
        "addressLocality": "부산진구",
        "addressRegion": "부산광역시",
        "addressCountry": "KR"
      },
      "geo": { "@type": "GeoCoordinates", "latitude": 35.1579, "longitude": 129.0590 },
      "openingHoursSpecification": [{ "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }]
    },
    {
      "@type": "LocalBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#haeundae`,
      "name": "부산호스트바 해운대지점",
      "parentOrganization": { "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#business` },
      "telephone": "+82-10-5781-5340",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "구남로 37",
        "addressLocality": "해운대구",
        "addressRegion": "부산광역시",
        "addressCountry": "KR"
      },
      "geo": { "@type": "GeoCoordinates", "latitude": 35.1588, "longitude": 129.1603 },
      "openingHoursSpecification": [{ "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }]
    },
    {
      "@type": "LocalBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#gwangalli`,
      "name": "부산호스트바 광안리지점",
      "parentOrganization": { "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#business` },
      "telephone": "+82-10-5781-5340",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "광안해변로 197",
        "addressLocality": "수영구",
        "addressRegion": "부산광역시",
        "addressCountry": "KR"
      },
      "geo": { "@type": "GeoCoordinates", "latitude": 35.1530, "longitude": 129.1185 },
      "openingHoursSpecification": [{ "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }]
    },
    {
      "@type": "LocalBusiness",
      "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#yeonsan`,
      "name": "부산호스트바 연산지점",
      "parentOrganization": { "@id": `${import.meta.env.VITE_SITE_URL ?? 'https://www.busanhostbar.net'}/#business` },
      "telephone": "+82-10-5781-5340",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "반송로 32-8",
        "addressLocality": "연제구",
        "addressRegion": "부산광역시",
        "addressCountry": "KR"
      },
      "geo": { "@type": "GeoCoordinates", "latitude": 35.1860, "longitude": 129.0820 },
      "openingHoursSpecification": [{ "@type": "OpeningHoursSpecification", "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"], "opens": "00:00", "closes": "23:59" }]
    }
  ]
};

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'home-schema-jsonld';
    script.textContent = JSON.stringify(SCHEMA_JSON);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById('home-schema-jsonld');
      if (existing) existing.remove();
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <Navigation isScrolled={isScrolled} />
      <Hero />
      <About />
      <Services />
      <Location />
      <FAQ />
      <Contact />
    </div>
  );
}
